import { Controller } from "@hotwired/stimulus";

const hiddenTabCss = ["hidden", "opacity-0", "animate-fadeOut"];
const activeTabCss = ["flex", "animate-fadeIn"];

export default class extends Controller {
  static classes = ["active", "inactive"];
  static targets = ["btn", "tab"];
  static values = { defaultTab: String };

  connect() {
    // first, hide all tabs
    this.tabTargets.map((x) => (x.hidden = true));

    this.btnTargets.forEach((button) => {
      button.classList.remove(...this.activeClasses);
      button.classList.add(...this.inactiveClasses);
    });

    // then, show the default tab
    let selectedTab = this.tabTargets.find(
      (element) => element.id === this.defaultTabValue
    );

    this.activateTab(selectedTab);
  }

  activateTab(tab) {
    let selectedBtn = this.btnTargets.find((element) => element.id === tab.id);
    selectedBtn.classList.remove(...this.inactiveClasses);
    selectedBtn.classList.add(...this.activeClasses);

    // Show the Tab Panel
    let selectedTab = this.tabForButton(selectedBtn);
    selectedTab.classList.remove(...hiddenTabCss);
    selectedTab.classList.add(...activeTabCss);

    let unselectedBtns = this.btnTargets.filter(
      (element) => element.id !== tab.id
    );

    unselectedBtns.forEach((button) => {
      button.classList.remove(...this.activeClasses);
      button.classList.add(...this.inactiveClasses);

      // Hide the Tab Panel
      let unselectedTab = this.tabForButton(button);
      unselectedTab.classList.remove(...activeTabCss);
      unselectedTab.classList.add(...hiddenTabCss);
    });
  }

  tabForButton(buttonTarget) {
    return this.tabTargets.find(
      (element) => element.id === buttonTarget.getAttribute("data-content-id")
    );
  }

  select(event) {
    let selectedTab = this.tabForButton(event.currentTarget);

    this.activateTab(selectedTab);
  }
}
